module.exports = __webpack_public_path__ + "img/1 (69).6dfdbf44.png";